import SCSS from 'assets/scss/PopUp.module.scss'
import FormSCSS from 'assets/scss/Form.module.scss'
import AppSCSS from 'assets/scss/App.module.scss'
import { useContext, useEffect, useState } from 'react'
import PageContext from 'global_state/context/PageContext'
import { BiCalendar } from 'react-icons/bi'
import { ProductI } from 'types/ProductI'
import Loader from 'components/Loader'
import { getPaymentGetwayService } from 'services/GetPaymentGetwayService'
import { PaymentsType } from 'types/PaymentsI'
import UserContext from 'global_state/context/UserContext'
import content from 'languages/BuyMembershipPopUp.json'

interface BuyMembershipPopUpProps {
    product: ProductI
}
function BuyMembershipPopUp(props: BuyMembershipPopUpProps) {
    let {page, dispatchPage} = useContext(PageContext)
    let {user, dispatchUser} = useContext(UserContext)
    let lang = page.settings.language

    const [loading, setLoading] = useState(false)
    const [buy_membership_response, setBuyMembershipResponse] = useState<any>()

    const getInputDate = (miliseconds: number) => {
        let date = new Date(miliseconds)
        return [
            date.getFullYear() , 
            ("0" + (date.getMonth() + 1)).slice(-2), 
            ("0" + date.getDate()).slice(-2)].join("-")
    }
    const [valid_from_date, setValidFromDate] = useState<any>(getInputDate(Date.now()))


    const handleSubmit = async (e) => {
        // console.log("handleSubmit PopUp");
        // console.log(e);
        
        
        e.preventDefault()
        setLoading(true)
        let name_string = JSON.stringify({
            name: props.product.description[lang],
            valid_from: valid_from_date
        })
        setBuyMembershipResponse(await getPaymentGetwayService(
            [{
                type: 'ITEM',
                // name: props.product.description + "_" + valid_from_date,
                name: name_string,
                // from: getInputDate(valid_from_date),
                amount: props.product.price_registration,
                count: 1
            }], 
            props.product.price_registration, 
            user.client_id,
            PaymentsType.memberships,
            lang,
            props.product.product_id.toString(),
            valid_from_date
        ))


    }
    const handleClosePopUp = (e) => {
        // console.log("handleClosePopUp");
        dispatchPage({
            type: "set_popup",
            payload: {
                popup: null,
            }
        })
    }
    const handleCahngeValidFrom = (e) => {
        // console.log(e.target.value);
        setValidFromDate(e.target.value)
    }

    useEffect(() => {
        // console.log(buy_membership_response);
        if (typeof buy_membership_response == 'object' && 'gw_url' in buy_membership_response) {
            window._gopay.checkout({gatewayUrl: buy_membership_response.gw_url, inline: true}, async (checkoutResult) => {

                if (checkoutResult.state == 'PAID') {
                    dispatchPage({
                        type: "add_notification",
                        payload: {
                            notification: {
                                type: "success",
                                message: "memberships_added_success"
                            }
                        }
                    }) 
                }
                if (checkoutResult.state != 'PAID') {
                    dispatchPage({
                        type: "add_notification",
                        payload: {
                            notification: {
                                type: "warning",
                                message: "membership_not_added"
                            }
                        }
                    }) 
                }

                // console.log("REMOVE POP-UP");
                dispatchPage({
                    type: "set_popup",
                    payload: {
                        popup: null
                    }
                })
            })

        }
        

    }, [buy_membership_response])

    const renderLoading = () => {
        if (loading) {
            return <Loader />
        }
        return null
    }
    const renderContent = () => {
        if (loading) {
            return null
        }
        return (
            <>
                <div className={SCSS.title}>
                    {props.product.name}
                </div>
                <div>
                    {props.product.description[lang]}
                </div>

                <label className={[FormSCSS.label, SCSS.label].join(" ")}>
                    <span className={SCSS.valid_text}>{content[lang].valid_from}</span>
                    <input 
                        // onChange={handle}
                        className={FormSCSS.input}
                        type="date" 
                        // value={"2022-08-29"}
                        onChange={(e) => handleCahngeValidFrom(e)}
                        value={valid_from_date}
                        min={getInputDate(Date.now())}
                        max={getInputDate(Date.now() + (14 * 24 * 60 * 60 * 1000))}
                    />
                    <span className={SCSS.icon}><BiCalendar/></span>
                    
                    
                </label>
                <button 
                    className={[AppSCSS.button, AppSCSS.red, SCSS.buy].join(" ")} 
                    type='submit'>
                    {content[lang].submit_button}
                </button>
            </>
        )
    }
    return (
        <div className={SCSS.buy_membership_popup}>
            <form 
                className={FormSCSS.form} 
                onSubmit={(e) => handleSubmit(e)}>

                <div className={SCSS.close}>
                    <button 
                        onClick={(e) => {handleClosePopUp(e)}}
                        className={[AppSCSS.button, AppSCSS.smaller, AppSCSS.no_shadow, AppSCSS.gray].join(" ")} 
                        type='button'>
                        {content[lang].close}
                    </button>
                </div>
                
                {renderLoading()}
                {renderContent()}


            </form>
        </div>

    )
}

export default BuyMembershipPopUp